import { put, call, select, delay } from 'redux-saga/effects';
import { selectForCallbackEnquiries } from './selectors';

import {
    fetchCallbackEnquiries,
    fetchPendingOrdersCount
} from './api';

import {
    sagaActions
} from './actions';

const { get_callback_enquiries, get_pending_orders_count } = sagaActions;

const fetchCallbackEnquirySaga = fetchAction.bind(null, get_callback_enquiries, fetchCallbackEnquiries);
const fetchPendingOrdersCountSaga = fetchAction.bind(null, get_pending_orders_count, fetchPendingOrdersCount);


function* fetchAction(action, apiFn, requestData) {
    yield put(action.request(requestData));
    const response = yield call(apiFn, requestData);

    if (response !== undefined) {
        yield put(action.success(response));
    } else {
        yield put(action.failure(yield call(apiFn, requestData)));
    }
}

export function* loadCallbackEnquiries() {
    while (true) {
        const user = yield select(selectForCallbackEnquiries);
        if (user) {
            yield call(fetchCallbackEnquirySaga);
            yield call(fetchPendingOrdersCountSaga);
            yield delay(30000);
        }
        yield delay(1000);
    }
}


// WEBPACK FOOTER //
// ./src/sagas/index.js